import { render, staticRenderFns } from "./EmployeesSalaryStatement.vue?vue&type=template&id=4fdb9985"
import script from "./EmployeesSalaryStatement.vue?vue&type=script&lang=js"
export * from "./EmployeesSalaryStatement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports